const config = { 
   API_URL: "https://b2c.apollocamper.com/vendor-service/v2/relocations/" 
}
export default config;